module.exports = __webpack_public_path__ + "img/09.143df015.jpg";